import clsx from "clsx";
import { MouseEventHandler } from "react";

import { FaRegStar, FaStar } from "react-icons/fa";
import { Button } from "~/components/ui";

const Star = ({
  starred,
  onClick,
}: {
  starred: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
}) => {
  return (
    <Button
      className={clsx("text-lg ", {})}
      onClick={onClick}
      ariaLabel="Star Button"
    >
      {starred ? (
        <FaStar className="text-blue" />
      ) : (
        <FaRegStar className="text-gray " />
      )}
    </Button>
  );
};

export default Star;
